import React from 'react'
import styles from './styles.module.scss'
import Arrow8 from '../../../assets/arrow'
import Arrow2 from '../../../assets/arrow2'
import Arrow3 from '../../../assets/arrow3'
import Arrow15 from '../../../assets/arrow4'

interface FloatingInfoBoxProps {
    message: React.ReactNode
    position: 'left' | 'right'
    showBox: boolean
    arrowsConfig?: {
        showBottomArrow?: boolean
        showTopArrow1?: boolean
        showTopArrow2?: boolean
        bottomArrowType?: 'arrow8' | 'arrow2' | 'arrow3' | 'arrow15'
        topArrow1Type?: 'arrow8' | 'arrow2' | 'arrow3' | 'arrow15'
        topArrow2Type?: 'arrow8' | 'arrow2' | 'arrow3' | 'arrow15'
    }
    customStyles?: React.CSSProperties
    className?: string
}

const FloatingInfoBox: React.FC<FloatingInfoBoxProps> = ({
    message,
    position,
    showBox,
    arrowsConfig = {
        showBottomArrow: false,
        showTopArrow1: false,
        showTopArrow2: false,
        bottomArrowType: 'arrow8',
        topArrow1Type: 'arrow2',
        topArrow2Type: 'arrow3',
    },
    customStyles = {},
    className = '',
}) => {
    const getArrowComponent = (arrowType: 'arrow8' | 'arrow2' | 'arrow3' | 'arrow15') => {
        switch (arrowType) {
            case 'arrow8':
                return <Arrow8 />
            case 'arrow2':
                return <Arrow2 />
            case 'arrow3':
                return <Arrow3 />
            case 'arrow15':
                return <Arrow15 />
            default:
                return <Arrow8 />
        }
    }

    return (
        <div
            className={`${styles.floatingInfoBox} ${styles[position]} ${!showBox ? styles.hidden : ''} ${className}`}
            style={customStyles}
        >
            {arrowsConfig.showTopArrow1 && (
                <div className={styles.topArrow1Container}>
                    {getArrowComponent(arrowsConfig.topArrow1Type || 'arrow2')}
                </div>
            )}

            {arrowsConfig.showTopArrow2 && (
                <div className={styles.topArrow2Container}>
                    {getArrowComponent(arrowsConfig.topArrow2Type || 'arrow3')}
                </div>
            )}

            {message}

            {arrowsConfig.showBottomArrow && (
                <div className={styles.bottomArrowContainer}>
                    {getArrowComponent(arrowsConfig.bottomArrowType || 'arrow8')}
                </div>
            )}
        </div>
    )
}

export default FloatingInfoBox
